import '.cf{position:relative;}.ssr-plugin'
import '.i2{width:64px;}.ssr-plugin'
import '.i3{height:64px;}.ssr-plugin'
import '.c0{flex-shrink:0;}.ssr-plugin'
import '.n{position:absolute;}.ssr-plugin'
import '.i4{bottom:-4px;}.ssr-plugin'
import '.ci{right:-4px;}.ssr-plugin'
import '.d1{border-radius:50%;}.ssr-plugin'
import '.i5{border:2px solid var(--shades-white);}.ssr-plugin'
import '.r{overflow:hidden;}.ssr-plugin'
import '.i6{width:32px;}.ssr-plugin'
import '.i7{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cf i2 i3 c0"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="n i4 ci d1 i5 r i6 i7"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
